import { createStore } from 'vuex'
import axios from 'axios'
export default createStore({
  state: {
    submitData:{
      deliver_zip:'',
      pickup_zip: '',
      zip: '',
      when: 'Binnen 1 week',
      email_address: '',
      name: '',
      lname: '',
      phone_number: '',
      commitment: '',
      storage_size: '',
      test_furnuture: 'This visitor did not use the calculator',
      source: 'Gamma',
      step: 'quote', //savedlist //quote
      link: '',
      order_type: "moving",
      company_source: 'gamma',
      src: 'tom',
      service: '',
    },
    //Flow data
    currentQuote: {
      size: 0,
      price: 0,
      commitment: 0,
      discountTxt: '',
      discountPrice: 0,
      link: '',
      service: '',
    },
    popup: true,
    quotes: [],
    currentStep: 0,
    stepOne: false,
    stepTwo: false,
    stepThree: false,
    instantCalculation: false,
    instantStep: 0,
    calculating: false,
    calculator: false,
    calculatorSize: 0,
    calculatorRounded: 0,
    currentType: 0,
    skip: false,
    customOffer:
    { 
      i: 0,
      size: 12,
      price: 107,
      type: 'Een paar spullen en/of dozen',
      transform: false,
      sizeSquare: '5.1',
      sqft: '55.0',
      maxW: '1.15',
      maxH: '2.35',
      maxL: '2.7',
      boxes: 'ca. 25 verhuisdozen',
      containers: 'ca. 4 rolcontainers',
      transporter: 'ca. 25% laadruimte VW-transporter',
      pou: 'thuis extra ruimte, kleine verbouwing, kleine verhuizing',
      },
    appointmentCta:{
      transform: false,
    },
    //calculator
    currentItems: [],
    savedLists: [],
    savedTotals: [],
    savedCalculations: [],
    savedCustoms: [],
    totals:{
      woonkamer: 0,
      keukenEetkamer: 0,
      slaapkamer: 0,
      garage: 0,
      zakelijk: 0,
    },
    woonkamer: [
      {
       nam: '2-zitsbank',
       value: 2.51,
       counter: 0,    
      },
      {
        nam: '3-zitsbank',
        value: 3.05,
        counter: 0,    
      },
      {
        nam: 'Hoekbank',
        value: 3,
        counter: 0,    
      },
      {
        nam: 'Poef',
        value: 0.3,
        counter: 0,    
      },
      {
        nam: 'Chaise longue',
        value: 2.2,
        counter: 0,    
      },
      {
        nam: 'Fauteuil',
        value: 1.33,
        counter: 0,    
      },
      {
        nam: 'Voetenbank',
        value: 0.2,
        counter: 0,    
      },
      {
        nam: 'Salontafel',
        value: 0.77,
        counter: 0,    
      },
      {
        nam: 'Tafeltje',
        value: 0.3,
        counter: 0,    
      },
      {
        nam: 'Boekenkast',
        value: 0.84,
        counter: 0,    
      },
      {
        nam: 'Dressoir',
        value: 1,
        counter: 0,    
      },
      {
        nam: 'TV-kastje',
        value: 0.5,
        counter: 0,    
      },
      {
        nam: 'Televisie',
        value: 0.53,
        counter: 0,    
      },
      {
        nam: 'Piano',
        value: 1.2,
        counter: 0,    
      },
      {
        nam: 'Vloerkleed',
        value: 0.66,
        counter: 0,    
      },
      {
        nam: 'Piano - klein',
        value: 1.2,
        counter: 0,    
      },
      {
        nam: 'Lijst',
        value: 0.1,
        counter: 0,    
      },
      {
        nam: 'Vitrinekast',
        value: 1,
        counter: 0,    
      },
      {
        nam: 'Verhuisdoos',
        value: 0.15,
        counter: 0,    
      },
    ],
    keukenEetkamer: [
      {
       nam: 'Eettafel(x4)',
       value: 2.2,
       counter: 0,    
      },
      {
        nam: 'Eettafel(x6)',
        value: 1,
        counter: 0,    
       },
      {
        nam: 'Eetkamerstoel',
        value: 0.59,
        counter: 0,    
      },
      {
        nam: '(bar)Kruk',
        value: 0.1,
        counter: 0,    
      },
      {
        nam: 'Kinderstoel',
        value: 0.2,
        counter: 0,    
      },
      {
        nam: 'Vitrinekast',
        value: 2.66,
        counter: 0,    
      },
      {
        nam: 'Buffertkast',
        value: 1,
        counter: 0,    
      },
      {
        nam: 'Vaatwasser',
        value: 0.7,
        counter: 0,    
      },
      {
        nam: 'Fornuis',
        value: 0.64,
        counter: 0,    
      },
      {
        nam: 'Magnetron',
        value: 0.16,
        counter: 0,    
      },
      {
        nam: 'Vuilnisbak',
        value: 0.31,
        counter: 0,    
      },
      {
        nam: 'Koelkast(tafelmodel)',
        value:1.3,
        counter: 0,    
      },
      {
        nam: 'Koelkast/Vriezer(klein)',
        value: 0.6,
        counter: 0,    
      },
      {
        nam: 'Vriezer(tafelmodel)',
        value: 1,
        counter: 0,    
      },
      {
        nam: 'Amerikaanse koelkast',
        value: 2.07,
        counter: 0,    
      },
      {
        nam: 'Verhuisdoos',
        value: 0.15,
        counter: 0,    
      },
    ],
    slaapkamer: [
      {
        nam: 'Kledingkast',
        value: 1.2,
        counter: 0,    
      },      
      {
        nam: 'Kinderbed',
        value: 0.7,
        counter: 0,    
      },
      {
        nam: '1 Persoonsbed(en matras)',
        value: 0.76,
        counter: 0,    
      },
      {
        nam: 'Nachtkastje',
        value: 0.31,
        counter: 0,    
      },
      {
        nam: 'Linnenkast(2 deurs)',
        value: 3.72,
        counter: 0,    
      },
      {
        nam: 'Linnenkast(3 deurs)',
        value: 3,
        counter: 0,    
      },
      {
        nam: 'Kaptafel',
        value: 0.8,
        counter: 0,    
      },
      {
        nam: 'Ladenkast',
        value: 0.95,
        counter: 0,    
      },
      {
        nam: 'Staande lamp',
        value: 0.26,
        counter: 0,    
      },
      {
        nam: 'Vloerkleed',
        value: 0.66,
        counter: 0,    
      },
      {
        nam: 'Spiegel(klein)',
        value: 0.1,
        counter: 0,    
      },
      {
        nam: 'Fotolijst',
        value: 0.2,
        counter: 0,    
      },
      {
        nam: 'Kunstplant',
        value: 0.5,
        counter: 0,    
      },
      {
        nam: 'Verhuisdoos',
        value: 0.15,
        counter: 0,    
      },
      {
        nam: '2 Persoonsbed(en matras)',
        value: 2.63,
        counter: 0,    
      },
    ],
    garage: [
      {
        nam: 'Tafel',
        value: 0.8,
        counter: 0,    
      },
      {
        nam: 'Tuinstoel',
        value: 1.32,
        counter: 0,    
      },
      {
        nam: 'Tuinbank',
        value: 0.5,
        counter: 0,    
      },
      {
        nam: 'Lounge set',
        value: 3,
        counter: 0,    
      },
      {
        nam: 'Parasol',
        value: 0.35,
        counter: 0,    
      },
      {
        nam: 'Grasmaaier(klein)',
        value: 0.4,
        counter: 0,    
      },
      {
        nam: 'Barbecue',
        value: 0.4,
        counter: 0,    
      },
      {
        nam: 'Fiets',
        value: 0.83,
        counter: 0,    
      },
      {
        nam: 'Kinderfiets',
        value: 0.53,
        counter: 0,    
      },
      {
        nam: 'Brommer(scooter)',
        value: 1.5,
        counter: 0,    
      },
      {
        nam: 'Gereedschap',
        value: 0.4,
        counter: 0,    
      },
      {
        nam: 'Werkbank',
        value: 1.1,
        counter: 0,    
       },
       {
         nam: 'Gereedschapskist',
         value: 0.2,
         counter: 0,    
       },
       {
         nam: 'Ladder',
         value: 0.49,
         counter: 0,    
       },
       {
         nam: 'Koffer',
         value: 0.35,
         counter: 0,    
       },
       {
         nam: 'Kerstboom',
         value: 0.3,
         counter: 0,    
       },
       {
        nam: 'Wasmachine',
        value: 0.64,
        counter: 0,    
       },
       {
         nam: 'Droger',
         value: 0.64,
         counter: 0,    
       },
       {
         nam: 'Droogrek',
         value: 0.49,
         counter: 0,    
       },
       {
         nam: 'Strijkplank',
         value: 0.24,
         counter: 0,    
       },
       {
         nam: 'Wasmand',
         value: 0.22,
         counter: 0,    
       },
       {
         nam: 'Stofzuiger',
         value: 0.2,
         counter: 0,    
       },
       {
         nam: 'Vuilnisbak',
         value: 0.3,
         counter: 0,    
       },
       {
         nam: 'Verhuisdoos',
         value: 0.15,
         counter: 0,   
       },
    ],
    zakelijk: [
      {
       nam: 'Europallet',
       value: 4.45,
       counter: 0,    
      },
      {
       nam: 'Blokpallet',
       value: 3.75,
       counter: 0,    
      },
      {
        nam: 'Bureau',
        value: 0.9,
        counter: 0,    
       },
       {
         nam: 'Bureaustoel',
         value: 0.85,
         counter: 0,    
       },
       {
         nam: 'Archiefkast',
         value: 0.8,
         counter: 0,    
       },
       {
         nam: 'Grote archiefkast',
         value: 3,
         counter: 0,    
       },
       {
         nam: 'Boekenkast',
         value: 0.84,
         counter: 0,    
       },
       {
         nam: 'Open kast',
         value: 2.2,
         counter: 0,    
       },
       {
         nam: 'Vuilnisbak',
         value: 0.1,
         counter: 0,    
       },
       {
         nam: 'Fotolijst',
         value: 0.2,
         counter: 0,    
       },
       {
         nam: 'Kunstplant',
         value: 0.5,
         counter: 0,    
       },
       {
        nam: 'Container',
        value: 70,
        counter: 0,    
       },
       {
        nam: 'Verhuisdoos',
        value: 0.15,
        counter: 0,    
       },
    ],
    
    //Offers
    offers: [
      // {
      // size: 4,
      // price: 40,
      // type: 'Grote Garderobekast',
      // transform: false,
      // sizeSquare: '1.7',
      // sqft: '18.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '1.4',
      // boxes: 'ca. 25 verhuisdozen',
      // containers: 'ca. 4 rolcontainers',
      // transporter: 'ca. 25% laadruimte VW transporter',
      // pou: 'paar kleine spullen, klein archief'
      // },
      // {
      // size: 6,
      // price: 56,
      // type: 'Kleine Tuinschuur',
      // transform: false,
      // sizeSquare: '2.6',
      // sqft: '27.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.2',
      // boxes: 'ca. 40 verhuisdozen',
      // containers: 'ca. 6 rolcontainers',
      // transporter: 'ca. 50% laadruimte VW transporter',
      // pou: 'paar kleine spullen, klein archief'
      // },
      // {
      // size: 8,
      // price: 74,
      // type: 'Grote Tuinschuur',
      // transform: false,
      // sizeSquare: '3.4',
      // sqft: '37.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 50 verhuisdozen',
      // containers: 'ca. 7 rolcontainers',
      // transporter: 'ca. 75% laadruimte VW transporter',
      // pou: 'paar spullen, klein archief',
      // },
      // {
      // size: 10,
      // price: 90,
      // type: 'Bestelbusje',
      // transform: false,
      // sizeSquare: '4.3',
      // sqft: '46.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 65 verhuisdozen',
      // containers: 'ca. 9 rolcontainers',
      // transporter: 'ca. 1 laadruimtes VW transporter',
      // pou: 'thuis extra ruimte, klein archief, kleine verhuizing',
      // },
      {
      size: 12,
      price: 107,
      type: 'Een paar spullen en/of dozen',
      transform: false,
      sizeSquare: '5.1',
      sqft: '55.0',
      maxW: '1.15',
      maxH: '2.35',
      maxL: '2.7',
      boxes: 'ca. 90 verhuisdozen',
      containers: 'ca. inboedel kleine studentenkamer',
      transporter: 'ca. eizoensopslag',
      pou: 'thuis extra ruimte, kleine verbouwing, kleine verhuizing',
      },
      // {
      // size: 14,
      // price: 123,
      // type: 'Hoge Bestelbus',
      // transform: false,
      // sizeSquare: '6.0',
      // sqft: '64.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 90 verhuisdozen',
      // containers: 'ca. 12 rolcontainers',
      // transporter: 'ca. 1,5 laadruimtes VW transporter',
      // pou: 'thuis extra ruimte, kleine verbouwing, kleine verhuizing',
      // },
      // {
      // size: 16,
      // price: 137,
      // type: 'Grote Bestelbus',
      // transform: false,
      // sizeSquare: '6.8',
      // sqft: '73.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 105 verhuisdozen',
      // containers: 'ca. 14 rolcontainers',
      // transporter: 'ca. 1,75 laadruimtes VW transporter',
      // pou: 'thuis extra ruimte, kleine verbouwing, kleine verhuizing',
      // },
      // {
      // size: 18,
      // price: 152,
      // type: 'Kleine bakwagen B rijbewijs',
      // transform: false,
      // sizeSquare: '7.7',
      // sqft: '82.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 120 verhuisdozen',
      // containers: 'ca. 16 rolcontainers',
      // transporter: 'ca. 2 laadruimtes VW transporter',
      // pou: 'kleine voorraad, kleine verbouwing, kleine verhuizing',
      // },
      // {
      // size: 20,
      // price: 167,
      // type: 'Kleine bakwagen B rijbewijs',
      // transform: false,
      // sizeSquare: '8.5',
      // sqft: '92.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 135 verhuisdozen',
      // containers: 'ca. 18 rolcontainers',
      // transporter: 'ca. 2,25 laadruimtes VW transporter',
      // pou: 'kleine voorraad, verbouwing, kleine verhuizing',
      // },
      // {
      // size: 22,
      // price: 181,
      // type: 'Groot Albert Heijn Bezorgbusje',
      // transform: false,
      // sizeSquare: '9.4',
      // sqft: '101.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 145 verhuisdozen',
      // containers: 'ca. 20 rolcontainers',
      // transporter: 'ca. 2,5 laadruimtes VW transporter',
      // pou: 'kleine voorraad, verbouwing, kleine verhuizing',
      // },
      {
      size: 24,
      price: 195,
      type: 'Kleine verhuizing',
      transform: false,
      sizeSquare: '10.2',
      sqft: '110.0',
      maxW: '1.15',
      maxH: '2.35',
      maxL: '2.7',
      boxes: 'ca. inboedel appartement met 2 slaapkamers',
      containers: 'ca. klein rijtjeshuis',
      transporter: 'ca. verbouwing 1e verdieping',
      pou: 'kleine voorraad, verbouwing, verhuizing',
      },
      // {
      // size: 26,
      // price: 206,
      // type: 'Kleine Vrachtwagen-bak',
      // transform: false,
      // sizeSquare: '11.1',
      // sqft: '119.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 170 verhuisdozen',
      // containers: 'ca. 23 rolcontainers',
      // transporter: 'ca. 0,5 laadruimtes VW transporter',
      // pou: 'voorraad, verbouwing, verhuizing',
      // },
      // {
      // size: 28,
      // price: 220,
      // type: 'Bakwagen',
      // transform: false,
      // sizeSquare: '11.9',
      // sqft: '128.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 185 verhuisdozen',
      // containers: 'ca. 25 rolcontainers',
      // transporter: 'ca. 3 laadruimtes VW transporter',
      // pou: 'voorraad, verbouwing, verhuizing',
      // },
      // {
      // size: 30,
      // price: 233,
      // type: 'Grote Vrachtwagen-bak',
      // transform: false,
      // sizeSquare: '12.8',
      // sqft: '137.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 200 verhuisdozen',
      // containers: 'ca. 27 rolcontainers',
      // transporter: 'ca. 3,25 laadruimtes VW transporter',
      // pou: 'voorraad, grote verbouwing, verhuizing',
      // },
      // {
      // size: 32,
      // price: 247,
      // type: '20 Voet Container',
      // transform: false,
      // sizeSquare: '13.6',
      // sqft: '147.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 210 verhuisdozen',
      // containers: 'ca. 29 rolcontainers',
      // transporter: 'ca. 3,5 laadruimtes VW transporter',
      // pou: 'voorraad, grote verbouwing, verhuizing',
      // },
      // {
      // size: 34,
      // price: 261,
      // type: '20 Voet Container',
      // transform: false,
      // sizeSquare: '14.5',
      // sqft: '156.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 225 verhuisdozen',
      // containers: 'ca. 31 rolcontainers',
      // transporter: 'ca. 3,75 laadruimtes VW transporter',
      // pou: 'voorraad, grote verbouwing, verhuizing',
      // },
      {
      size: 36,
      price: 271,
      type: 'Een verhuizing',
      transform: false,
      sizeSquare: '15.3',
      sqft: '165.0',
      maxW: '1.15',
      maxH: '2.35',
      maxL: '2.7',
      boxes: 'ca. ruime eengezinswoning inboedel',
      containers: 'ca. grootschalige renovatie',
      transporter: 'ca. inboedel groot appartement',
      pou: 'voorraad, grote verbouwing, grote verhuizing',
      },
      // {
      // size: 38,
      // price: 283,
      // type: 'Gem.inboedel 1 Gezins HuisHouden',
      // transform: false,
      // sizeSquare: '16.2',
      // sqft: '174.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 250 verhuisdozen',
      // containers: 'ca. 34 rolcontainers',
      // transporter: 'ca. 4 laadruimtes VW transporter',
      // pou: 'grote verhuizing',
      // },
      // {
      // size: 40,
      // price: 296,
      // type: 'Garagebox',
      // transform: false,
      // sizeSquare: '17.0',
      // sqft: '183.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 265 verhuisdozen',
      // containers: 'ca. 36 rolcontainers',
      // transporter: 'ca. 4,25 laadruimtes VW transporter',
      // pou: 'grote verhuizing',
      // },
      // {
      // size: 42,
      // price: 307,
      // type: 'Garagebox',
      // transform: false,
      // sizeSquare: '17.9',
      // sqft: '192.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 280 verhuisdozen',
      // containers: 'ca. 38 rolcontainers',
      // transporter: 'ca. 4,5 laadruimtes VW transporter',
      // pou: 'grote verhuizing',
      // },
      // {
      // size: 44,
      // price: 319,
      // type: 'Garagebox',
      // transform: false,
      // sizeSquare: '18.7',
      // sqft: '202.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 290 verhuisdozen',
      // containers: 'ca. 40 rolcontainers',
      // transporter: 'ca. 4,75 laadruimtes VW transporter',
      // pou: 'grote verhuizing',
      // },
      // {
      // size: 46,
      // price: 327,
      // type: 'Grote Garagebox',
      // transform: false,
      // sizeSquare: '19.6',
      // sqft: '211.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 300 verhuisdozen',
      // containers: 'ca. 42 rolcontainers',
      // transporter: 'ca. 5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // },
      {
      size: 48,
      price: 338,
      type: 'Een verhuizing',
      transform: false,
      sizeSquare: '20.4',
      sqft: '220.0',
      maxW: '1.15',
      maxH: '2.35',
      maxL: '2.7',
      boxes: 'ca. groot gezinswoning met 5 kamers',
      containers: 'ca. verbouwing groot huis',
      transporter: 'ca. zakelijke opslag, apparatuur, kantoor meubels etc.',
      pou: 'bedrijfsverhuizing',
      },
      // {
      // size: 50,
      // price: 350,
      // type: 'Grote Garagebox',
      // transform: false,
      // sizeSquare: '21.3',
      // sqft: '229.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 330 verhuisdozen',
      // containers: 'ca. 45 rolcontainers',
      // transporter: 'ca. 5,5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // },
      // {
      // size: 60,
      // price: 413,
      // type: 'Oppervlakte 2 Ouder Slaapkamers',
      // transform: false,
      // sizeSquare: '25.5',
      // sqft: '275.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 400 verhuisdozen',
      // containers: 'ca. 54 rolcontainers',
      // transporter: 'ca. 6,5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // },
      // {
      // size: 70,
      // price: 473,
      // type: '2x Gem.inboedel 1 Gezins HuisHouden',
      // transform: false,
      // sizeSquare: '29.8',
      // sqft: '321.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 465 verhuisdozen',
      // containers: 'ca. 63 rolcontainers',
      // transporter: 'ca. 7,5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // },
      // {
      // size: 80,
      // price: 531,
      // type: 'Dubbele Garagebox',
      // transform: false,
      // sizeSquare: '34.0',
      // sqft: '366.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 530 verhuisdozen',
      // containers: 'ca. 72 rolcontainers',
      // transporter: 'ca. 8,5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',

      // },
      // {
      // size: 90,
      // price: 587,
      // type: 'Grote Vrachtwagen Oplegger',
      // transform: false,
      // sizeSquare: '38.3',
      // sqft: '412.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 600 verhuisdozen',
      // containers: 'ca. 81 rolcontainers',
      // transporter: 'ca. 9,5 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // },
      // {
      // size: 100,
      // price: 640,
      // type: 'Grote vrachtwagen Oplegger',
      // transform: false,
      // sizeSquare: '42.6',
      // sqft: '458.0',
      // maxW: '1.15',
      // maxH: '2.35',
      // maxL: '2.7',
      // boxes: 'ca. 650 verhuisdozen',
      // containers: 'ca. 90 rolcontainers',
      // transporter: 'ca. 11 laadruimtes VW transporter',
      // pou: 'bedrijfsverhuizing',
      // }
    ],
    regions: [
      {
       'region':'Amsterdam',
       'city':'Amsterdam overig',
       'start':1000,
       'end':1010,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam centrum',
       'start':1011,
       'end':1012,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Sloterdijk',
       'start':1013,
       'end':1014,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam centrum',
       'start':1015,
       'end':1020,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Noord',
       'start':1021,
       'end':1037,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Sloterdijk',
       'start':1038,
       'end':1050,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam West',
       'start':1051,
       'end':1070,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Zuid',
       'start':1071,
       'end':1084,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Oost',
       'start':1085,
       'end':1099,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam Zuidoost',
       'start':1100,
       'end':1109,
      },
      {
       'region':'Amsterdam',
       'city':'Diemen',
       'start':1110,
       'end':1113,
      },
      {
       'region':'Amsterdam',
       'city':'Amsterdam',
       'start':1114,
       'end':1127,
      },
      {
       'region':'Amsterdam',
       'city':'Boven Amsterdam',
       'start':1128,
       'end':1156,
      },
      {
       'region':'Amsterdam',
       'city':'Lijnden en andere plaatsen',
       'start':1157,
       'end':1179,
      },
      {
       'region':'Amsterdam',
       'city':'Amstelveen',
       'start':1180,
       'end':1189,
      },
      {
       'region':'Amsterdam',
       'city':'Ouderkerk Amstel',
       'start':1190,
       'end':1199,
      },
      {
       'region':'Hilversum',
       'city':'Hilversum',
       'start':1200,
       'end':1223,
      },
      {
       'region':'Hilversum',
       'city':'Wijdemeren etc',
       'start':1224,
       'end':1261,
      },
      {
       'region':'Hilversum',
       'city':'Huizen etc',
       'start':1262,
       'end':1299,
      },
      {
       'region':'Almere',
       'city':'Almere',
       'start':1300,
       'end':1363,
      },
      {
       'region':'Hilversum',
       'city':'Weesp, Bussum, Aalsmeer, etc',
       'start':1364,
       'end':1439,
      },
      {
       'region':'Purmerend',
       'city':'Purmerend',
       'start':1440,
       'end':1448,
      },
      {
       'region':'Almere',
       'city':'Plaatsen Noord-Holland',
       'start':1449,
       'end':1499,
      },
      {
       'region':'Zaandam',
       'city':'Zaandam',
       'start':1500,
       'end':1509,
      },
      {
       'region':'Zaandstad',
       'city':'Zaanstad',
       'start':1510,
       'end':1567,
      },
      {
       'region':'Alkmaar',
       'city':'Bovenin Noord-Holland',
       'start':1568,
       'end':1699,
      },
      {
       'region':'Heerhugowaard',
       'city':'Heerhugowaard',
       'start':1700,
       'end':1705,
      },
      {
       'region':'Kop van Noord-Holland',
       'city':'Ver bovenin Noord-Holland',
       'start':1706,
       'end':1779,
      },
      {
       'region':'Den Helder',
       'city':'Den Helder',
       'start':1780,
       'end':1788,
      },
      {
       'region':'Texel',
       'city':'Texel',
       'start':1789,
       'end':1799,
      },
      {
       'region':'Alkmaar',
       'city':'Alkmaar',
       'start':1800,
       'end':1834,
      },
      {
       'region':'Alkmaar',
       'city':'Rondom Alkmaar',
       'start':1835,
       'end':1939,
      },
      {
       'region':'Beverwijk',
       'city':'Beverwijk en Velsen-Noord',
       'start':1940,
       'end':1959,
      },
      {
       'region':'Heemskerk',
       'city':'Heemskerk',
       'start':1960,
       'end':1969,
      },
      {
       'region':'Ijmuiden',
       'city':'Ijmuiden, Velsen',
       'start':1970,
       'end':1999,
      },
      {
       'region':'Haarlem',
       'city':'Haarlem',
       'start':2000,
       'end':2037,
      },
      {
       'region':'Zandvoort',
       'city':'Zandvoort',
       'start':2038,
       'end':2042,
      },
      {
       'region':'Haarlem',
       'city':'Bloemendaal etc',
       'start':2043,
       'end':2062,
      },
      {
       'region':'Haarlem',
       'city':'Omgeving Haarlem',
       'start':2063,
       'end':2099,
      },
      {
       'region':'Heemstede',
       'city':'Heemstede',
       'start':2100,
       'end':2106,
      },
      {
       'region':'Haarlem',
       'city':'Omgeving Haarlem 2',
       'start':2107,
       'end':2129,
      },
      {
       'region':'Hoofddorp',
       'city':'Hoofddorp',
       'start':2130,
       'end':2135,
      },
      {
       'region':'Haarlem',
       'city':'Haarlemmermeer',
       'start':2136,
       'end':2159,
      },
      {
       'region':'Lisse',
       'city':'Lisse',
       'start':2160,
       'end':2163,
      },
      {
       'region':'Leiden',
       'city':'Sassenheim',
       'start':2164,
       'end':2179,
      },
      {
       'region':'Leiden',
       'city':'Hillegom',
       'start':2180,
       'end':2182,
      },
      {
       'region':'Leiden',
       'city':'Noordwijk',
       'start':2183,
       'end':2219,
      },
      {
       'region':'Leiden',
       'city':'Katwijk aan Zee',
       'start':2220,
       'end':2235,
      },
      {
       'region':'Wassenaar',
       'city':'Wassenaar',
       'start':2236,
       'end':2245,
      },
      {
       'region':'Voorschoten',
       'city':'Voorschoten',
       'start':2246,
       'end':2259,
      },
      {
       'region':'Den Haag',
       'city':'Voorburg Leidschendam',
       'start':2260,
       'end':2279,
      },
      {
       'region':'Rijswijk',
       'city':'Rijswijk',
       'start':2280,
       'end':2289,
      },
      {
       'region':'Den Haag',
       'city':'Wateringen',
       'start':2290,
       'end':2299,
      },
      {
       'region':'Leiden',
       'city':'Leiden',
       'start':2300,
       'end':2334,
      },
      {
       'region':'Leiden',
       'city':'Omgeving Leiden',
       'start':2335,
       'end':2399,
      },
      {
       'region':'Alphen aan den Rijn',
       'city':'Alphen aan den Rijn',
       'start':2400,
       'end':2409,
      },
      {
       'region':'Bodegraven',
       'city':'Bodegraven',
       'start':2410,
       'end':2479,
      },
      {
       'region':'Leiden',
       'city':'Woubrugge',
       'start':2480,
       'end':2489,
      },
      {
       'region':'Den Haag',
       'city':'Den Haag',
       'start':2490,
       'end':2583,
      },
      {
       'region':'Den Haag',
       'city':'Scheveningen, omgeving DH',
       'start':2584,
       'end':2599,
      },
      {
       'region':'Delft',
       'city':'Delft',
       'start':2600,
       'end':2629,
      },
      {
       'region':'Den Haag',
       'city':'Nootdorp',
       'start':2630,
       'end':2649,
      },
      {
       'region':'Berkel en Rodenrijs',
       'city':'Berkel en Rodenrijs',
       'start':2650,
       'end':2659,
      },
      {
       'region':'Rotterdam',
       'city':'Bergschenhoek',
       'start':2660,
       'end':2699,
      },
      {
       'region':'Zoetermeer',
       'city':'Zoetermeer',
       'start':2700,
       'end':2729,
      },
      {
       'region':'Leiden',
       'city':'Rijnwoude',
       'start':2730,
       'end':2739,
      },
      {
       'region':'Waddinxveen',
       'city':'Waddinxveen',
       'start':2740,
       'end':2769,
      },
      {
       'region':'Waddinxveen',
       'city':'Boskoop',
       'start':2770,
       'end':2799,
      },
      {
       'region':'Gouda',
       'city':'Gouda',
       'start':2800,
       'end':2809,
      },
      {
       'region':'Gouda',
       'city':'Reeuwijk',
       'start':2810,
       'end':2839,
      },
      {
       'region':'Gouda',
       'city':'Moordrecht',
       'start':2840,
       'end':2849,
      },
      {
       'region':'Gouda',
       'city':'Haastrecht',
       'start':2850,
       'end':2859,
      },
      {
       'region':'Gouda',
       'city':'Bergambacht',
       'start':2860,
       'end':2899,
      },
      {
       'region':'Capelle aan den Ijssel',
       'city':'Capelle aan den Ijssel',
       'start':2900,
       'end':2909,
      },
      {
       'region':'Nieuwerkerk aan den IJssel',
       'city':'Nieuwerkerk aan den IJssel',
       'start':2910,
       'end':2919,
      },
      {
       'region':'Krimpen aan den IJssel',
       'city':'Krimpen aan den IJssel',
       'start':2920,
       'end':2926,
      },
      {
       'region':'Krimpen aan den IJssel',
       'city':'Lekkerkerk etc',
       'start':2927,
       'end':2949,
      },
      {
       'region':'Dordrecht',
       'city':'Alblasserdam etc',
       'start':2950,
       'end':2963,
      },
      {
       'region':'Dordrecht',
       'city':'Groot-Ammers',
       'start':2964,
       'end':2964,
      },
      {
       'region':'Dordrecht',
       'city':'Graafstroom',
       'start':2965,
       'end':2979,
      },
      {
       'region':'Rotterdam',
       'city':'Ridderkerk',
       'start':2980,
       'end':2989,
      },
      {
       'region':'Rotterdam',
       'city':'Barendrecht',
       'start':2990,
       'end':2999,
      },
      {
       'region':'Rotterdam',
       'city':'Rotterdam',
       'start':3000,
       'end':3099,
      },
      {
       'region':'Schiedam',
       'city':'Schiedam',
       'start':3100,
       'end':3129,
      },
      {
       'region':'Schiedam',
       'city':'Vlaardingen',
       'start':3130,
       'end':3139,
      },
      {
       'region':'Schiedam',
       'city':'Maassluis',
       'start':3140,
       'end':3179,
      },
      {
       'region':'Spijkenisse',
       'city':'Rozenburg',
       'start':3180,
       'end':3189,
      },
      {
       'region':'Spijkenisse',
       'city':'Hoogvliet',
       'start':3190,
       'end':3199,
      },
      {
       'region':'Spijkenisse',
       'city':'Spijkenisse',
       'start':3200,
       'end':3210,
      },
      {
       'region':'Spijkenisse',
       'city':'Bernisse',
       'start':3211,
       'end':3219,
      },
      {
       'region':'Spijkenisse',
       'city':'Hellevoetsluis',
       'start':3220,
       'end':3225,
      },
      {
       'region':'Spijkenisse',
       'city':'Oud Beijerland etc',
       'start':3226,
       'end':3299,
      },
      {
       'region':'Dordrecht',
       'city':'Dordrecht',
       'start':3300,
       'end':3329,
      },
      {
       'region':'Dordrecht',
       'city':'Zwijndrecht',
       'start':3330,
       'end':3339,
      },
      {
       'region':'Dordrecht',
       'city':'Hendrik-Ido-Ambacht',
       'start':3340,
       'end':3349,
      },
      {
       'region':'Dordrecht',
       'city':'Papendrecht',
       'start':3350,
       'end':3356,
      },
      {
       'region':'Dordrecht',
       'city':'Sliedrecht etc',
       'start':3357,
       'end':3399,
      },
      {
       'region':'Utrecht',
       'city':'Ijsselstein',
       'start':3400,
       'end':3429,
      },
      {
       'region':'Nieuwegein',
       'city':'Nieuwegein',
       'start':3430,
       'end':3439,
      },
      {
       'region':'Woerden',
       'city':'Woerden',
       'start':3440,
       'end':3499,
      },
      {
       'region':'Utrecht',
       'city':'Utrecht noordkant',
       'start':3500,
       'end':3510,
      },
      {
       'region':'Utrecht',
       'city':'Utrecht - centrum',
       'start':3511,
       'end':3513,
      },
      {
       'region':'Utrecht',
       'city':'Utrecht zuidkant',
       'start':3514,
       'end':3550,
      },
      {
       'region':'Utrecht',
       'city':'Utrecht noordkant',
       'start':3551,
       'end':3599,
      },
      {
       'region':'Maarssen',
       'city':'Maarssen',
       'start':3600,
       'end':3619,
      },
      {
       'region':'Breukelen',
       'city':'Breukelen etc',
       'start':3620,
       'end':3639,
      },
      {
       'region':'Loenen',
       'city':'Loenen etc',
       'start':3640,
       'end':3699,
      },
      {
       'region':'Amersfoort',
       'city':'Baarn, de Bilt etc',
       'start':3700,
       'end':3799,
      },
      {
       'region':'Amersfoort',
       'city':'Amersfoort',
       'start':3800,
       'end':3826,
      },
      {
       'region':'Amersfoort',
       'city':'Leusden',
       'start':3827,
       'end':3839,
      },
      {
       'region':'Amersfoort',
       'city':'Harderwijk, Ermelo',
       'start':3840,
       'end':3859,
      },
      {
       'region':'Amersfoort',
       'city':'Nijkerk',
       'start':3860,
       'end':3889,
      },
      {
       'region':'Amersfoort',
       'city':'Putten',
       'start':3860,
       'end':3889,
      },
      {
       'region':'Flevoland',
       'city':'Zeewolde',
       'start':3860,
       'end':3889,
      },
      {
       'region':'Veenendaal',
       'city':'Veenendaal',
       'start':3900,
       'end':3907,
      },
      {
       'region':'Veenendaal',
       'city':'Rhenen',
       'start':3908,
       'end':3924,
      },
      {
       'region':'Utrecht',
       'city':'Utrechtse Heuvelrug',
       'start':3925,
       'end':3959,
      },
      {
       'region':'Houten',
       'city':'Wijk bij Duurstede',
       'start':3960,
       'end':3969,
      },
      {
       'region':'Houten',
       'city':'Driebergen',
       'start':3970,
       'end':3972,
      },
      {
       'region':'Houten',
       'city':'Bunnik',
       'start':3973,
       'end':3989,
      },
      {
       'region':'Houten',
       'city':'Houten',
       'start':3990,
       'end':3999,
      },
      {
       'region':'Tiel',
       'city':'Tiel, etc',
       'start':4000,
       'end':4099,
      },
      {
       'region':'Tiel',
       'city':'Culemborg, Buren',
       'start':4100,
       'end':4119,
      },
      {
       'region':'Vianen',
       'city':'Vianen',
       'start':4120,
       'end':4139,
      },
      {
       'region':'Tiel',
       'city':'Geldermalsen etc.',
       'start':4140,
       'end':4199,
      },
      {
       'region':'Gorinchem',
       'city':'Gorinchem',
       'start':4200,
       'end':4213,
      },
      {
       'region':'Nieuwegein',
       'city':'Zederik (Zuid-Holland)',
       'start':4214,
       'end':4249,
      },
      {
       'region':'Dordrecht',
       'city':'Werkendam (Brabant)',
       'start':4250,
       'end':4299,
      },
      {
       'region':'Zeeland',
       'city':'Schouwen Duiveland',
       'start':4300,
       'end':4329,
      },
      {
       'region':'Zeeland',
       'city':'Middelburg etc',
       'start':4330,
       'end':4379,
      },
      {
       'region':'Zeeland',
       'city':'Vlissingen etc',
       'start':4380,
       'end':4399,
      },
      {
       'region':'Zeeland',
       'city':'Goes, etc',
       'start':4400,
       'end':4499,
      },
      {
       'region':'Zeeland',
       'city':'Sluis, etc',
       'start':4500,
       'end':4529,
      },
      {
       'region':'Zeeland',
       'city':'Terneuzen, Hulst',
       'start':4530,
       'end':4599,
      },
      {
       'region':'Bergen op Zoom',
       'city':'Bergen op Zoom',
       'start':4600,
       'end':4625,
      },
      {
       'region':'Bergen op Zoom',
       'city':'Woensdrecht',
       'start':4626,
       'end':4649,
      },
      {
       'region':'Bergen op Zoom',
       'city':'Steenbergen',
       'start':4650,
       'end':4659,
      },
      {
       'region':'Bergen op Zoom',
       'city':'Bergen op Zoom 2',
       'start':4660,
       'end':4669,
      },
      {
       'region':'Bergen op Zoom',
       'city':'Tholen, Steenbergen',
       'start':4670,
       'end':4699,
      },
      {
       'region':'Roosendaal',
       'city':'Roosendaal',
       'start':4700,
       'end':4709,
      },
      {
       'region':'Roosendaal',
       'city':'Rucphen, Halderberge',
       'start':4710,
       'end':4759,
      },
      {
       'region':'Breda',
       'city':'Moerdijk',
       'start':4760,
       'end':4799,
      },
      {
       'region':'Breda',
       'city':'Breda',
       'start':4800,
       'end':4845,
      },
      {
       'region':'Breda',
       'city':'Alphen Chaam',
       'start':4846,
       'end':4869,
      },
      {
       'region':'Breda',
       'city':'Etten-Leur',
       'start':4870,
       'end':4879,
      },
      {
       'region':'Breda',
       'city':'Zundert',
       'start':4880,
       'end':4899,
      },
      {
       'region':'Oosterhout',
       'city':'Oosterhout',
       'start':4900,
       'end':4919,
      },
      {
       'region':'Oosterhout',
       'city':'Geertruidenberg',
       'start':4920,
       'end':4999,
      },
      {
       'region':'Tilburg',
       'city':'Tilburg',
       'start':5000,
       'end':5049,
      },
      {
       'region':'Tilburg',
       'city':'Oisterwijk, Goirle',
       'start':5050,
       'end':5079,
      },
      {
       'region':'Tilburg',
       'city':'Hilverenbeek',
       'start':5080,
       'end':5099,
      },
      {
       'region':'Tilburg',
       'city':'Dongen',
       'start':5100,
       'end':5119,
      },
      {
       'region':'Tilburg',
       'city':'Gilze en Rijen',
       'start':5126,
       'end':5129,
      },
      {
       'region':'Waalwijk',
       'city':'Waalwijk',
       'start':5130,
       'end':5169,
      },
      {
       'region':'Tilburg',
       'city':'Loon op Zand',
       'start':5170,
       'end':5199,
      },
      {
       'region':'Den Bosch',
       'city':'Den Bosch',
       'start':5200,
       'end':5239,
      },
      {
       'region':'Den Bosch',
       'city':'Brabant, Boxtel etc',
       'start':5240,
       'end':5299,
      },
      {
       'region':'Den Bosch',
       'city':'Zaltbommel, Maasdriel',
       'start':5300,
       'end':5339,
      },
      {
       'region':'Oss',
       'city':'Oss, Uden, etc',
       'start':5340,
       'end':5409,
      },
      {
       'region':'Nijmegen',
       'city':'Cuijk, Brabant',
       'start':5410,
       'end':5459,
      },
      {
       'region':'Eindhoven',
       'city':'Veghel, etc',
       'start':5460,
       'end':5499,
      },
      {
       'region':'Eindhoven',
       'city':'Veldhoven',
       'start':5500,
       'end':5509,
      },
      {
       'region':'Eindhoven',
       'city':'Valkenswaard, etc',
       'start':5510,
       'end':5599,
      },
      {
       'region':'Eindhoven',
       'city':'Eindhoven',
       'start':5600,
       'end':5659,
      },
      {
       'region':'Eindhoven',
       'city':'Geldrop, Nuenen',
       'start':5660,
       'end':5679,
      },
      {
       'region':'Eindhoven',
       'city':'Best, Brabant',
       'start':5680,
       'end':5699,
      },
      {
       'region':'Eindhoven',
       'city':'Helmond',
       'start':5700,
       'end':5709,
      },
      {
       'region':'Eindhoven',
       'city':'Deurne, Brabant, etc',
       'start':5710,
       'end':5765,
      },
      {
       'region':'Eindhoven',
       'city':'Venray',
       'start':5766,
       'end':5819,
      },
      {
       'region':'Nijmegen',
       'city':'Boxmeer, Sint Anthonis',
       'start':5820,
       'end':5849,
      },
      {
       'region':'Oss',
       'city':'Bergen, Limburg',
       'start':5850,
       'end':5899,
      },
      {
       'region':'Venlo',
       'city':'Venlo',
       'start':5900,
       'end':5959,
      },
      {
       'region':'Venlo',
       'city':'Horst, Limburg omgeving',
       'start':5960,
       'end':5999,
      },
      {
       'region':'Venlo',
       'city':'Weert',
       'start':6000,
       'end':6019,
      },
      {
       'region':'Venlo',
       'city':'Cranendonck',
       'start':6020,
       'end':6029,
      },
      {
       'region':'Sittard',
       'city':'Sittard',
       'start':6030,
       'end':6129,
      },
      {
       'region':'Sittard',
       'city':'Sittard 2',
       'start':6130,
       'end':6199,
      },
      {
       'region':'Maastricht',
       'city':'Maastricht',
       'start':6200,
       'end':6229,
      },
      {
       'region':'Maastricht',
       'city':'Meerssen',
       'start':6230,
       'end':6249,
      },
      {
       'region':'Maastricht',
       'city':'Valkenburg etc',
       'start':6250,
       'end':6324,
      },
      {
       'region':'Heerlen',
       'city':'Heerlen, etc',
       'start':6325,
       'end':6469,
      },
      {
       'region':'Nijmegen',
       'city':'Nijmegen en omgeving',
       'start':6470,
       'end':6559,
      },
      {
       'region':'Nijmegen',
       'city':'Gennep, etc',
       'start':6560,
       'end':6599,
      },
      {
       'region':'Nijmegen',
       'city':'Wijchen, etc',
       'start':6600,
       'end':6619,
      },
      {
       'region':'Nijmegen',
       'city':'West Maas en Waal',
       'start':6620,
       'end':6639,
      },
      {
       'region':'Nijmegen',
       'city':'Overbetuwe',
       'start':6640,
       'end':6699,
      },
      {
       'region':'Veenendaal',
       'city':'Wageningen',
       'start':6700,
       'end':6709,
      },
      {
       'region':'Veenendaal',
       'city':'Ede',
       'start':6710,
       'end':6799,
      },
      {
       'region':'Arnhem',
       'city':'Arnhem',
       'start':6800,
       'end':6849,
      },
      {
       'region':'Arnhem',
       'city':'Renkum, Rheden',
       'start':6850,
       'end':6905,
      },
      {
       'region':'Arnhem',
       'city':'Rijnwaarden',
       'start':6906,
       'end':6919,
      },
      {
       'region':'Doetinchem',
       'city':'Gelderland omgeving Doetinchem',
       'start':6920,
       'end':6999,
      },
      {
       'region':'Doetinchem',
       'city':'Doetinchem, Oude Ijsselstreek',
       'start':7000,
       'end':7089,
      },
      {
       'region':'Doetinchem',
       'city':'Winterswijk etc',
       'start':7090,
       'end':7149,
      },
      {
       'region':'Doetinchem',
       'city':'Groenlo',
       'start':7150,
       'end':7199,
      },
      {
       'region':'Apeldoorn',
       'city':'Zutphen',
       'start':7200,
       'end':7269,
      },
      {
       'region':'Enschede',
       'city':'Berkelland',
       'start':7270,
       'end':7299,
      },
      {
       'region':'Apeldoorn',
       'city':'Apeldoorn',
       'start':7300,
       'end':7379,
      },
      {
       'region':'Apeldoorn',
       'city':'Deventer',
       'start':7380,
       'end':7439,
      },
      {
       'region':'Enschede',
       'city':'Rijssen, etc',
       'start':7440,
       'end':7479,
      },
      {
       'region':'Enschede',
       'city':'Enschede',
       'start':7480,
       'end':7549,
      },
      {
       'region':'Hengelo',
       'city':'Hengelo, Oldenzaal',
       'start':7550,
       'end':7579,
      },
      {
       'region':'Enschede',
       'city':'Losser, Dinkelland',
       'start':7580,
       'end':7599,
      },
      {
       'region':'Enschede',
       'city':'Almelo',
       'start':7600,
       'end':7629,
      },
      {
       'region':'Enschede',
       'city':'Hardenberg etc',
       'start':7630,
       'end':7699,
      },
      {
       'region':'Enschede',
       'city':'Ommen',
       'start':7700,
       'end':7739,
      },
      {
       'region':'Enschede',
       'city':'Coevorden',
       'start':7740,
       'end':7769,
      },
      {
       'region':'Enschede',
       'city':'Hardenberg 2',
       'start':7770,
       'end':7799,
      },
      {
       'region':'Emmen',
       'city':'Emmen',
       'start':7800,
       'end':7899,
      },
      {
       'region':'Emmen',
       'city':'Hoogeveen',
       'start':7900,
       'end':7939,
      },
      {
       'region':'Emmen',
       'city':'Meppel',
       'start':7940,
       'end':7969,
      },
      {
       'region':'Emmen',
       'city':'Westerveld',
       'start':7970,
       'end':7999,
      },
      {
       'region':'Zwolle',
       'city':'Zwolle',
       'start':8000,
       'end':8069,
      },
      {
       'region':'Zwolle',
       'city':'Nunspeet',
       'start':8070,
       'end':8099,
      },
      {
       'region':'Zwolle',
       'city':'Dalfsen',
       'start':8100,
       'end':8159,
      },
      {
       'region':'Zwolle',
       'city':'Epe, Gelderland',
       'start':8160,
       'end':8199,
      },
      {
       'region':'Lelystad',
       'city':'Lelystad',
       'start':8200,
       'end':8249,
      },
      {
       'region':'Lelystad',
       'city':'Dronten',
       'start':8250,
       'end':8259,
      },
      {
       'region':'Lelystad',
       'city':'Flevoland',
       'start':8260,
       'end':8324,
      },
      {
       'region':'Heerenveen',
       'city':'Steenwijk',
       'start':8325,
       'end':8379,
      },
      {
       'region':'Heerenveen',
       'city':'Heerenveen, etc',
       'start':8380,
       'end':8424,
      },
      {
       'region':'Heerenveen',
       'city':'Oosterwolde etc',
       'start':8425,
       'end':8439,
      },
      {
       'region':'Heerenveen',
       'city':'Heerenveen, Joure',
       'start':8440,
       'end':8528,
      },
      {
       'region':'Heerenveen',
       'city':'Franeker, Harlingen',
       'start':8529,
       'end':8879,
      },
      {
       'region':'Waddeneilanden',
       'city':'Terschelling, Vlieland',
       'start':8880,
       'end':8899,
      },
      {
       'region':'Leeuwarden',
       'city':'Leeuwarden en omgeving',
       'start':8900,
       'end':9099,
      },
      {
       'region':'Leeuwarden',
       'city':'Friesland',
       'start':9100,
       'end':9159,
      },
      {
       'region':'Waddeneilanden',
       'city':'Ameland, Schier',
       'start':9160,
       'end':9169,
      },
      {
       'region':'Friesland',
       'city':'Friesland 2',
       'start':9170,
       'end':9289,
      },
      {
       'region':'Friesland',
       'city':'Friesland/Drenthe',
       'start':9290,
       'end':9354,
      },
      {
       'region':'Groningen',
       'city':'Leek, Marum',
       'start':9355,
       'end':9399,
      },
      {
       'region':'Assen',
       'city':'Assen, Beilen, Midden-Drenthe',
       'start':9400,
       'end':9442,
      },
      {
       'region':'Assen',
       'city':'Aa en Hunze',
       'start':9443,
       'end':9469,
      },
      {
       'region':'Assen',
       'city':'Drenthe omgeving Assen',
       'start':9470,
       'end':9499,
      },
      {
       'region':'Assen',
       'city':'Stadskanaal, bovenin Drenthe',
       'start':9500,
       'end':9539,
      },
      {
       'region':'Groningen',
       'city':'Vlagtwedde, Groningen',
       'start':9540,
       'end':9599,
      },
      {
       'region':'Groningen',
       'city':'Veendam, Slochteren',
       'start':9600,
       'end':9669,
      },
      {
       'region':'Groningen',
       'city':'Winschoten, Scheemda',
       'start':9670,
       'end':9699,
      },
      {
       'region':'Groningen',
       'city':'Groningen',
       'start':9700,
       'end':9749,
      },
      {
       'region':'Groningen',
       'city':'Haren',
       'start':9750,
       'end':9759,
      },
      {
       'region':'Groningen',
       'city':'Omgeving Groningen',
       'start':9760,
       'end':9799,
      },
      {
       'region':'Groningen',
       'city':'Groningen/Friesland',
       'start':9800,
       'end':9879,
      },
      {
       'region':'Groningen',
       'city':'Appingedam, Zuidhorn',
       'start':9880,
       'end':9903,
      },
      {
       'region':'Groningen',
       'city':'Winsum, bovenin Groningen',
       'start':9904,
       'end':9999,
      },
   ],
  },
  mutations: {
    changeCurrentStep(state, payload) {
      state.currentStep = payload;
    },
    changeSubmitData(state,payload){
      state.submitData[payload.item] = payload.new
    },
    changeCurrentQuote(state,payload){
      state.currentQuote[payload.item] = payload.new
    },
    changeInstantCalculation(state,payload){
      state.instantCalculation= payload
    },
    changeCalculating(state,payload){
      state.calculating= payload
    },
    changeCalculatorSize(state,payload){
      state.calculatorSize= payload
    },
    changeCalculatorRounded(state,payload){
      state.calculatorRounded= payload
    },
    changePopup(state,payload){
      state.popup= payload
    },
    completeStep(state,payload){
      state[payload]= true
    },
    changeCalculator(state,payload){
      for (let i=0; i<state.offers.length; i++)
        state.offers[i].transform =false
      state.calculator= payload
    },
    changeCustomOffer(state,payload){
      state.customOffer = state.offers[payload]
      state.customOffer.i=payload
      state.customOffer.transform = false
    },
    resetCalculator(state){
      state.calculatorSize = 0
      state.calculatorRounded = 0
      state.customOffer = state.offers[0]
      for (let i=0; i<state.woonkamer.length; i++)
        state.woonkamer[i].counter =0
      for (let i=0; i<state.keukenEetkamer.length; i++)
        state.keukenEetkamer[i].counter =0
      for (let i=0; i<state.slaapkamer.length; i++)
        state.slaapkamer[i].counter =0
      for (let i=0; i<state.garage.length; i++)
        state.garage[i].counter =0
      for (let i=0; i<state.zakelijk.length; i++)
        state.zakelijk[i].counter =0
      state.totals.woonkamer = 0
      state.totals.keukenEetkamer = 0
      state.totals.slaapkamer = 0
      state.totals.kinderkamer = 0
      state.totals.garage = 0
      state.totals.zakelijk = 0
      state.currentItems = []            
    },
    changeSkip(state, payload){
      state.skip = payload
    },
    appendQuote (state, quote) {
      state.quotes[0]= quote;
    },
    removeQuote (state, payload) {
      state.quotes.splice(payload,1)
    },
    appendCurrentItems (state, item) {
      state.currentItems.push(item);
    },
    removeItemFromCurrent (state, payload) {
      state.currentItems.splice(payload,1)
    },
    appendSavedLists (state, list) {
      state.savedLists.push(list);
    },
    appendSavedCalculations(state,calculation){
      state.savedCalculations.push(calculation)
    },
    appendSavedCustoms(state,custom){
      state.savedCustoms.push(custom)
    }
  },
  getters: {
    quotes: state => {
      return state.quotes;
    },
    currentItems: state => {
      return state.currentItems;
    },
    savedLists: state => {
      return state.savedLists;
    },
    savedCalculations: state => {
      return state.savedCalculations;
    },
    savedCustoms: state => {
      return state.savedCalculations;
    },    
  },
  actions: {
    addQuote (state, payload) {
      state.commit('appendQuote', payload);
    },
    addCurrentItems(state, payload){
      state.commit('appendCurrentItems',payload)
    },
    addSavedLists(state, payload){
      state.commit('appendSavedLists',payload)
    },
    addSavedCalculations(state, payload){
      state.commit('appendSavedCalculations',payload)
    },
    addSavedCustoms(state, payload){
      state.commit('appendSavedCustoms',payload)
    },
  },
  modules: {
  }
})
